"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuickEventProperty = exports.quickEventPropertyDefinition = void 0;
exports.quickEventPropertyDefinition = {
    view: { label: 'Quick Event' },
    constraints: [],
    type: 'boolean',
    multiple: false,
    default: false,
    name: 'quick-event',
};
const isQuickEventProperty = (prop) => {
    return prop.name === exports.quickEventPropertyDefinition.name;
};
exports.isQuickEventProperty = isQuickEventProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVpY2stZXZlbnQucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9xdWljay1ldmVudC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUU7SUFDOUIsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsU0FBUztJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsT0FBTyxFQUFFLEtBQUs7SUFDZCxJQUFJLEVBQUUsYUFBYTtDQUNZLENBQUE7QUFJMUIsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLElBQWtCLEVBQThCLEVBQUU7SUFDckYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG9DQUE0QixDQUFDLElBQUksQ0FBQTtBQUN4RCxDQUFDLENBQUE7QUFGWSxRQUFBLG9CQUFvQix3QkFFaEMifQ==